import { render, staticRenderFns } from "./EventsReport.vue?vue&type=template&id=4a193ec8&scoped=true"
import script from "./EventsReport.vue?vue&type=script&lang=js"
export * from "./EventsReport.vue?vue&type=script&lang=js"
import style0 from "./EventsReport.vue?vue&type=style&index=0&id=4a193ec8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a193ec8",
  null
  
)

export default component.exports